import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { AuthenticationService } from '../services/index';
import { AvatarModule } from 'ngx-avatar';
@NgModule({
    imports: [ RouterModule, CommonModule, AvatarModule ],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ],
    providers: [AuthenticationService]
})

export class SidebarModule {}
